import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { PillarArticle, articleJsonLdForPillar } from "@/components/site/PillarArticle";
import { ShopifyPlusCostCalculator } from "@/components/site/ShopifyPlusCostCalculator";
import { buildHead, breadcrumbJsonLd, faqJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import { SHOPIFY_PLUS_PRICING_COPY } from "@/lib/competitive-gap-resource-content";

const PATH = "/resources/shopify-plus-pricing";
const ALT = "/es/recursos/precios-shopify-plus";
const COPY = SHOPIFY_PLUS_PRICING_COPY.en;
const PUBLISHED = "2026-08-24T18:45:00.000Z";
const MODIFIED = "2026-11-04T17:00:00.000Z";
const TITLE = "Shopify Plus cost in 2026: $2,300–$2,500/month + fees and TCO";
const META_TITLE = "Shopify Plus Pricing 2026: $2,300–$2,500/mo + Fees | Shugert";
const DESCRIPTION =
  "Shopify Plus costs $2,500 USD/month on a 1-year contract or $2,300/month on a 3-year contract, before payments, apps, integrations, migration and engineering.";
const INTRO =
  "Shopify documents Plus at $2,500 USD per month on a one-year contract or $2,300 USD per month on a three-year contract (Shopify Help Center). That platform fee is only the baseline: the useful buying number is total cost of ownership across payments, apps, integrations, migration and ongoing engineering.";

export const Route = createFileRoute("/resources/shopify-plus-pricing")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en",
    title: META_TITLE,
    description: DESCRIPTION,
    path: PATH,
    altPath: ALT,
    type: "article",
    author: "Samuel Noriega",
    articleAuthor: "Samuel Noriega",
    articleSection: "Shopify Plus economics",
    publishedTime: PUBLISHED,
    modifiedTime: MODIFIED,
    jsonLd: [
      articleJsonLdForPillar({
        title: TITLE,
        description: DESCRIPTION,
        path: PATH,
        publishedTime: PUBLISHED,
        modifiedTime: MODIFIED,
        section: "Shopify Plus economics",
      }),
      breadcrumbJsonLd([
        { name: "Home", path: "/" },
        { name: "Resources", path: "/resources" },
        { name: "Shopify Plus Pricing", path: PATH },
      ]),
      faqJsonLd(COPY.faqs),
    ],
  }),
  component: () => (
    <SiteShell>
      <PillarArticle
        locale="en"
        path={PATH}
        eyebrow={COPY.eyebrow}
        title={TITLE}
        intro={INTRO}
        updated="November 4, 2026"
        readingMinutes={COPY.readingMinutes}
        hubHref="/resources"
        hubLabel="Browse all resources"
        sections={COPY.sections}
        faqs={COPY.faqs}
        related={COPY.related}
        midCTA={COPY.midCTA}
        finalCTA={COPY.finalCTA}
        publishedTime={PUBLISHED}
        modifiedTime={MODIFIED}
        guideLabel="Decision guide"
        afterIntro={<ShopifyPlusCostCalculator locale="en" />}
      />
    </SiteShell>
  ),
});
